import { ResetPasswordRecoveryPasswordCompleteNamespace } from '@core/models/client';

export namespace ResetPasswordRecoveryPasswordCompleteApiNamespace {
  export class IN {
    passwordrequestreference: string = '';
    password: string = '';
    //captchaToken: string = '';
    constructor(input: ResetPasswordRecoveryPasswordCompleteNamespace.IN) {
      this.password = input.password;
      this.passwordrequestreference = input.token;
      //this.captchaToken = input.recaptchaToken;
    }
  }

  export class OUT {
    // recoverPasswordKey: string = '';
  }
}
